import script from "./SimpleModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleModal.vue?vue&type=script&setup=true&lang=js"

import "./SimpleModal.vue?vue&type=style&index=0&id=614c5b0e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-614c5b0e"]])

export default __exports__